<template>
	<v-card
		flat
		width="500px"
	>
		<v-card-title class="secondary--text">
			<span>Filtri</span>
			<v-spacer></v-spacer>
		</v-card-title>
		<v-card-text>
			<v-row>
				<v-col>
					<v-switch
						v-model="computedConAggiornamentiNellePratiche"
						label="Mostra solo gli accordi che hanno delle Attività"
						inset
					></v-switch>
				</v-col>
			</v-row>
		</v-card-text>
		<v-card-actions>
			<v-btn
				@click="resetFilters()"
				color="info"
			>
				Azzera filtri
			</v-btn>
			<v-spacer></v-spacer>
			<v-btn
				@click="closeDialog()"
				color="tertiary"
				class="black--text"
			>
				Annulla
			</v-btn>
			<v-btn
				@click="applyFilters()"
				color="secondary"
				:disabled="isLoading"
			>
				Filtra
			</v-btn>
		</v-card-actions>
	</v-card>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from "vuex";
export default {
	data() {
		return {
		
		}
	},
	
	created() {
	
	},
	
	computed: {
		...mapGetters({
			defaultFilters: 'accordiFilters/defaultFilters',
			conAggiornamentiNellePratiche: 'accordiFilters/conAggiornamentiNellePratiche'
		}),
		computedConAggiornamentiNellePratiche: {
			get: function () {
				return this.conAggiornamentiNellePratiche.value;
			},
			set: function (value) {
				this.setConAggiornamentiNellePraticheNotApplied(value);
			}
		},
		isLoading() {
			return false;
		}
	},
	
	methods: {
		...mapMutations({
			setConAggiornamentiNellePraticheNotApplied: 'accordiFilters/SET_CON_AGGIORNAMENTI_NELLE_PRATICHE_NON_APPLIED'
		}),
		...mapActions({
			applyFiltersAction: 'accordiFilters/applyFilters',
			resetFiltersAction: 'accordiFilters/resetFilters',
		}),
		applyFilters() {
			this.applyFiltersAction();
			this.$emit('reload-accordi');
			this.closeDialog();
		},
		resetFilters() {
			this.resetFiltersAction();
			this.$emit('reload-accordi');
			this.closeDialog();
		},
		closeDialog() {
			this.$emit('close');
		}
	}
}
</script>

<style scoped>

</style>